import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: true,
  error: false,
  data: null,
};

export const apiSlice = createSlice({
  name: "api",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLoading } = apiSlice.actions;

export default apiSlice.reducer;
